// This ensures that deviceType, custom site, and other params stick around after state transitions
export default function persistQueryParams($rootScope, $location) {
  var locationSearch = '';

  $rootScope.$on('$stateChangeStart', () => {
    locationSearch = $location.search();
  });

  return $rootScope.$on('$stateChangeSuccess', () =>
    $location.search(locationSearch)
  );
}

persistQueryParams.$inject = ['$rootScope', '$location'];
